<template>
  <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" v-on="$listeners" />
  <svg
    v-else
    :class="svgClass"
    :style="{ color: isHovered ? hoverColor : iconColor }"
    aria-hidden="true"
    v-on="$listeners"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
// doc: https://panjiachen.github.io/vue-element-admin-site/feature/component/svg-icon.html#usage
import { isExternal } from '@/utils/validate'

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    hoverColor: {
      type: String,
      default: 'currentColor'
    }
  },
  data() {
    return {
      isHovered: false
    };
  },
  computed: {
    isExternal() {
      return isExternal(this.iconClass)
    },
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${this.iconClass}) no-repeat 50% 50%`,
        backgroundColor: this.color,
        fill: this.color,
        color: this.color
      }
    },
    iconColor() {
      return this.color
    }
  },
  mounted() {
    // console.log('Icon color:', this.iconColor);
  }
}
</script>
<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  overflow: hidden;
}
.svg-external-icon {
  mask-size: cover!important;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue